import { render, staticRenderFns } from "./hsiiItems.vue?vue&type=template&id=dad8647c&scoped=true"
import script from "./hsiiItems.vue?vue&type=script&lang=js"
export * from "./hsiiItems.vue?vue&type=script&lang=js"
import style0 from "./hsiiItems.vue?vue&type=style&index=0&id=dad8647c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dad8647c",
  null
  
)

export default component.exports